<div class="heading">
  <h2>پروفایل ولتاژ خودرو</h2>
  <small>بر مبنای داده‌های همان روز، بدون آستانه ثابت ۱۲ یا ۲۴ ولت</small>
</div>

<ng-container *ngIf="profile.hasData; else empty">
  <div class="profile-rows">
    <div class="profile-row" *ngFor="let row of profile.rows">
      <span>{{ row.label }}</span>
      <strong dir="ltr" *ngIf="row.value != null; else unavailable">{{ row.value | number:'1.2-2':'en-US' }} V</strong>
    </div>
  </div>

  <div class="interpretation">
    <strong>تفسیر هوشمند</strong>
    <p>
      <span *ngIf="profile.movingAverage != null">میانگین ولتاژ هنگام حرکت <bdi>{{ profile.movingAverage | number:'1.2-2':'en-US' }} V</bdi> است. </span>
      <span *ngIf="profile.offAverage != null">میانگین ولتاژ موتور خاموش <bdi>{{ profile.offAverage | number:'1.2-2':'en-US' }} V</bdi> است. </span>
      <span *ngIf="profile.movingAverage == null && profile.offAverage == null">برای مقایسه ولتاژ هنگام حرکت و خاموشی، دادهٔ کافی موجود نیست. </span>
      این الگو صرفاً توصیف داده‌های همین روز است؛ برای تشخیص قطعی وضعیت موتور باید سوابق و ورودی‌های معتبر دیگر نیز بررسی شوند.
    </p>
  </div>
</ng-container>

<ng-template #empty><div class="empty" role="status">دادهٔ معتبری برای نمایش پروفایل ولتاژ موجود نیست.</div></ng-template>
<ng-template #unavailable><span class="unavailable" aria-label="اطلاعات موجود نیست">—</span></ng-template>
